import React from "react";
import Header, { navItems } from "./components/Header";
import Hero from "./components/Hero";
import {
  About,
  Experience,
  Projects,
  Skills,
  Certifications,
  Contact,
  Footer,
} from "./components/Sections";
import { useActiveSection, useCardGlow, useReveal } from "./components/hooks";

const sectionIds = navItems.map((item) => item.id);

function App() {
  useReveal();
  useCardGlow();
  const active = useActiveSection(sectionIds);

  return (
    <>
      <Header active={active} />
      <main>
        <Hero />
        <About />
        <Experience />
        <Projects />
        <Skills />
        <Certifications />
        <Contact />
      </main>
      <Footer />
    </>
  );
}

export default App;
